<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('销毁我的团队.我的团队')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="mb-30 flex items-center justify-between rounded-22 h-90 bg-white/10">
					<div @click="setQueryInfo(1)" :class="[queryInfo.type == 1 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('销毁我的团队.邀请好友')}}</span>
					</div>
					<div @click="setQueryInfo(2)" :class="[queryInfo.type == 2 ? 'bg-primary' : '']"
						class="rounded-22 flex-1 h-90 flex items-center justify-center">
						<span class="text-32 text-white">{{$t('销毁我的团队.团队列表')}}</span>
					</div>
				</div>
				<!-- 邀请好友 -->
				<div v-if="queryInfo.type == 1" class="">
					<div class="mt-20 bg-white/10 rounded-20 flex items-center justify-between p-30">
						<div class="flex-1 flex flex-col items-center justify-center">
							<img class="w-72 h-72" src="@/assets/images/pages/destroy-team/ztrs.png" alt="" />
							<span class="mt-10 text-50 font-bold text-white">{{direct}}</span>
							<span class="text-20 text-#999">{{$t('销毁我的团队.直推人数')}}</span>
						</div>
						<div class="w-2 h-60 bg-white/10"></div>
						<div class="flex-1 flex flex-col items-center justify-center">
							<img class="w-72 h-72" src="@/assets/images/pages/destroy-team/ztsy.png" alt="" />
							<span class="mt-10 text-50 font-bold text-white">{{direct_bouns}}</span>
							<span class="text-20 text-#999">{{$t('销毁我的团队.直推收益')}}</span>
						</div>
					</div>
<!--					<div class="mt-20 bg-white/10 rounded-20 p-30">-->
<!--						<div>-->
<!--							<span class="text-36 text-white">{{$t('销毁我的团队.我的邀请码')}}</span>-->
<!--						</div>-->
<!--						<div class="mt-20 rounded-12 flex items-center justify-between h-100 px-20"-->
<!--							style="background-color: #101011;">-->
<!--							<span class="text-36 font-bold text-#999">ROON2024XYZ</span>-->
<!--							<div class="h-60 px-20 bg-primary/20 rounded-10 flex items-center justify-center">-->
<!--								<span class="text-primary text-28">{{$t('销毁我的团队.复制')}}</span>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
					<div class="mt-20 bg-white/10 rounded-20 p-30">
						<div>
							<span class="text-36 text-white">{{$t('销毁我的团队.我的邀请码')}}</span>
						</div>
						<div class="mt-20 rounded-12 flex items-center justify-between h-100 px-20 text-ellipsis-1"
							style="background-color: #101011;">
							<span
								class="text-26 font-bold text-#999 text-ellipsis-1">{{share_url}}</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="rounded-full bg-primary/20 h-100 flex-1 mr-10 flex items-center justify-center" @click="onCopy(share_url)">
								<span class="text-primary text-32">{{$t('销毁我的团队.复制链接')}}</span>
							</div>
<!--							<div class="rounded-full bg-primary h-100 flex-1 m6-10 flex items-center justify-center">-->
<!--								<span class="text-white text-32">{{$t('销毁我的团队.分享链接')}}</span>-->
<!--							</div>-->
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("销毁我的团队.邀请规则")}}</span>
						</div>
						<div class="mt-20  rounded-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.直推好友销毁可获得5%奖励")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.团队等级越高，极差收益越多")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.NFT节点极差:1%-5%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.矿机领航者极差:1%-5%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.流动性挖矿极差:R1-R10(1%-10%)")}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 团队列表 -->
				<div v-else-if="queryInfo.type == 2" class="">
					<div class="bg-white/10 rounded-20 p-30">
						<div class=" flex items-center">
							<img class="w-88 h-88" src="@/assets/images/pages/destroy-team/tdjl.png" alt="" />
							<div class="ml-20">
								<div>
									<span class="text-36 text-white">{{$t('销毁我的团队.质押NFT解锁团队奖励')}}</span>
								</div>
								<div class="mt-10">
									<span
										class="text-24 text-#999">{{$t('销毁我的团队.质押NFT后可获得团队极差奖励(1%-5%)，享受更多收益')}}</span>
								</div>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="mr-10 flex-1 bg-primary h-100 rounded-full flex items-center justify-center" @click="getjieyaClick(2)">
								<span class="text-32 text-white">{{$t('销毁我的团队.质押NFT')}}</span>
							</div>
							<div class="ml-10 flex-1 bg-white/10 h-100 rounded-full flex items-center justify-center" @click="getjieyaClick(1)">
								<span class="text-32 text-white">解押NFT</span>
							</div>
						</div>
					</div>
					<div class="mt-20 destroy-team-item1-bg-image rounded-20 p-30">
						<div class="flex items-center justify-between">
							<img class="w-88 h-88" src="@/assets/images/pages/destroy-team/dj.png" alt="" />
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-24 text-#999">{{$t('销毁我的团队.我的等级')}}</span>
									<div class="px-20 rounded-10 flex items-center justify-center h-42 bg-gradient-tb-#FF9A41-#FF8316">
										<span class="text-20 text-white">{{jicha_rato}}%{{$t('销毁我的团队.极差')}}</span>
									</div>
								</div>
								<div class="">
									<span class="text-36 text-white font-bold">{{vip_name}}</span>
								</div>
							</div>
						</div>
						<div class="mt-30 flex items-center justify-between">
							<div class="rounded-20 px-40 py-30 flex-1 mr-10" style="background-color: #2D2D2F;">
								<div>
									<span class="text-20 text-white">{{$t('销毁我的团队.直推收益')}}</span>
								</div>
								<div class="mt-20 flex items-center">
									<span class="text-36 text-white font-bold">{{direct_bouns}}</span>
								</div>
								<div class="mt-10">
									<span class="text-20 text-white">ROON</span>
								</div>
							</div>
							<div class=" rounded-20 px-40 py-30 flex-1 ml-10" style="background-color: #2D2D2F;">
								<div>
									<span class="text-20 text-white">{{$t('销毁我的团队.团队收益')}}</span>
								</div>
								<div class="mt-20 flex items-center">
									<span class="text-36 text-white font-bold">{{team_bouns}}</span>
								</div>
								<div class="mt-10">
									<span class="text-20 text-white">ROON</span>
								</div>
							</div>
						</div>
					</div>
<!--					<div class="mt-20 flex items-center justify-between">-->
<!--						<div class="destroy-team-item2-bg-image flex items-center justify-center">-->
<!--							<div class="flex flex-col items-center justify-center">-->
<!--								<div>-->
<!--									<span class="text-40 font-bold" style="color: #FF0101;">{{direct}}</span>-->
<!--								</div>-->
<!--								<div>-->
<!--									<span class="text-20 text-#ccc">{{$t('销毁我的团队.直推人数')}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="destroy-team-item2-bg-image flex items-center justify-center">-->
<!--							<div class="flex flex-col items-center justify-center">-->
<!--								<div>-->
<!--									<span class="text-40 font-bold" style="color: #01BAFF;">200</span>-->
<!--								</div>-->
<!--								<div>-->
<!--									<span class="text-20 text-#ccc">{{$t('销毁我的团队.团队总人数')}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="destroy-team-item2-bg-image flex items-center justify-center">-->
<!--							<div class="flex flex-col items-center justify-center">-->
<!--								<div>-->
<!--									<span class="text-40 font-bold" style="color: #01FF6D;">200</span>-->
<!--								</div>-->
<!--								<div>-->
<!--									<span class="text-20 text-#ccc">{{$t('销毁我的团队.团队销毁量')}}</span>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->
					<div class="mt-20 mb-20 flex items-center justify-between">
						<span class="text-36 text-white">{{$t('销毁我的团队.直推成员')}}</span>
						<div>
							<span class="text-28 text-white">{{$t('销毁我的团队.共')}}</span>
							<span class="text-28 text-white">5</span>
							<span class="text-28 text-white">{{$t('销毁我的团队.人')}}</span>
						</div>
					</div>
					<div v-for="(item, index) in direct_list" :key="index" class="bg-white/10 p-20 rounded-20 mb-20">
						<div class="flex items-center justify-between">
							<div class="flex items-center justify-center">
								<img class="text-58 h-58" src="@/assets/images/pages/destroy-team/ztcy.png" alt="" />
							</div>
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-32 text-white font-bold">{{item.show_address}}</span>
									<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
										style="border-color:#50B428; background-color: #50B42820;">
										<span class="text-20 text-white">{{item.lpvip.name}}</span>
									</div>
								</div>
								<div class="flex items-center justify-between">
									<span class="text-20 text-#ccc">{{item.created_at}}</span>
								</div>
							</div>
						</div>
<!--						<div class="mt-20 flex items-center justify-between">-->
<!--							<div class="rounded-12 flex-1 mr-10 h-110 p-20">-->
<!--								<div class="">-->
<!--									<span class="text-20 text-#999">{{$t("销毁我的团队.直推收益")}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-32 font-bold" style="color: #01BAFF;">67.4</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="rounded-12 flex-1 mr-10 h-110 p-20">-->
<!--								<div class="">-->
<!--									<span class="text-20 text-#999">{{$t("销毁我的团队.团队收益")}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-32 font-bold" style="color: #FF881F;">67.4</span>-->
<!--								</div>-->
<!--							</div>-->
<!--							<div class="rounded-12 flex-1  h-110 p-20">-->
<!--								<div class="">-->
<!--									<span class="text-20 text-#999">{{$t("销毁我的团队.销毁量")}}</span>-->
<!--								</div>-->
<!--								<div class="mt-10">-->
<!--									<span class="text-32 font-bold" style="color: #EB470C;">67.4</span>-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
						<div class="">
							<span class="text-white text-36">{{$t("销毁我的团队.等级说明")}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.R1-R10:流动性挖矿等级，极差1%-10%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.NFT节点:质押NFT获得，极差1%-5%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.矿机领航者:团队销毁达标，极差1%-5%")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("销毁我的团队.等级越高，团队收益越多")}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-destroy activeMenu="destroy-team"></menu-bar-destroy>
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("销毁我的团队.质押NFT")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20 mx-20">
							<span class="text-26 text-#999 text-center">{{$t("销毁我的团队.质押NFT后将解锁团队极差奖励功能，享受1%-5%的团队收益分成")}}</span>
						</div>
						<div class="rounded-18 bg-#1B1B1B  mt-20 mx-20 p-30">
							<div class="flex items-center justify-between">
								<span class="text-24 text-white">{{$t("销毁我的团队.NFT数量")}}</span>
								<span class="text-24 text-white">1{{$t("销毁我的团队.个")}}</span>
							</div>
							<div class="mt-30 flex items-center justify-between pb-20 "
								style="border-bottom-color: #454545;">
								<span class="text-24 text-white">{{$t("销毁我的团队.质押周期")}}</span>
								<span class="text-24 text-primary">{{$t("销毁我的团队.永久")}}</span>
							</div>
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-white">{{$t("销毁我的团队.团队极差")}}</span>
								<span class="text-24 text-success">1% - 5%</span>
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false"
								class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
								<span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
							</div>
							<div @click="showAmountPopup = false"
								class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('销毁我的团队.确认质押')}}</span>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

            <!-- 质押 解押 -->
			 <van-popup v-model="jiepop" position="bottom" @close="jiepop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t('选择NFT解押')}}</span>
						<img src="@/assets/images/common/icon_gb.png" @click="jiepop=false" class="icon_gb" alt="">
					</div>
					<div class="dqian">
						<img src="@/assets/images/common/jiebg.png" class="jiebg" alt="">
						<div class="dqnavs">
							<img src="@/assets/images/common/hguan.png" class="hguan" alt="">
							<div class="dright">
								<span class="djie">当前等级：{{vip_name}}</span>
<!--								<span class="djietwo">{{$t('jiemiao')}}</span>-->
							</div>
						</div>
					</div>
					<span class="yixuan">质押中<span class="yixuannum">({{nft_staking_count}}{{$t('个')}}NFT)</span></span>
					<div class="plist">
						<div class="pitem" v-for="(item,index) in nft_stakings" :key="index">
							<img :src="item.token.img" class="img_logoimg" alt="">
							<div class="pnav">
								<div class="pnavone">
									<span class="pnavname">{{item.token.name}}</span>
									<span class="pnabiao">#{{item.token.id}}</span>
<!--									<div class="bqitem">-->
<!--										<div class="bqnav">Level3-{{$t('黄金')}}</div>-->
<!--									</div>-->
								</div>
								<div class="jieyabtnnew" @click="extract(item)">{{$t('解押')}}</div>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

			 <van-popup v-model="zhiyapop" position="bottom" @close="zhiyapop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t('选择NFT质押')}}</span>
						<img src="@/assets/images/common/icon_gb.png" @click="zhiyapop=false" class="icon_gb" alt="">
					</div>
					<div class="dqian">
						<img src="@/assets/images/common/jiebg.png" class="jiebg" alt="">
						<div class="dqnavs">
							<img src="@/assets/images/common/hguan.png" class="hguan" alt="">
							<div class="dright">
								<span class="djie">当前等级：{{vip_name}}</span>
<!--								<span class="djietwo">{{$t('zhimiao')}}</span>-->
							</div>
						</div>
					</div>
					<span class="yixuan">拥有<span class="yixuannum">({{nft_count}}{{$t('个')}}NFT)</span></span>
					<div class="plist">
						<div class="pitem" v-for="(item,index) in nfts" :key="index">
							<img :src="item.img" class="img_logoimg" alt="">
							<div class="pnav">
								<div class="pnavone">
									<span class="pnavname">{{item.name}}</span>
									<span class="pnabiao">#{{item.id}}</span>
									<div class="bqitem">
										<div class="bqnav">余额：{{item.balance}}</div>
									</div>
								</div>
                                <div class="jieyabtnnew" @click="staking(item)">质押</div>
							</div>
						</div>
					</div>
				</div>

			</van-popup>

            <van-popup v-model="loadingPopup" :close-on-click-overlay="false" style="background-color: transparent;">
                <div class="flex flex-col items-center justify-center p-30 rounded-20" style="background-color: rgba(0,0,0,0.8);">
                    <van-loading type="spinner" color="#EB470C" size="40px" />
                    <span class="mt-20 text-white text-28">{{$t('加载中...')}}</span>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarDestroy from '@/components/menu-bar-destroy/menu-bar-destroy.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	import nodeNft from "@/abi/nodeNftAbi";
    import SimpleERC1155StakingAbi from "@/abi/SimpleERC1155StakingAbi"
	export default {
		components: {
			homeNav,
			menuBarDestroy,
		},
		data() {
			return {
				triggered: false,
				more: 1,
                direct: 0,
                jicha_rato: 0,
                team_bouns: 0,
                direct_bouns: 0,
                share_url: "",
                vip_name: "",
				typeList: [],
                direct_list: [],
                UserStakeIds: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
				showAmountPopup: false,
                nft_staking_address: "0xC8b9755f01ccc17922a76c201cBE4Ef3e088b22F",
                nft_address: "0x027e7dE1469E0fd88e5EE4b5AebB596a0cb7e1C6",
                paying: false,
                loadingPopup: false,
                address: "",
                web3Provider: null,
				web3: null,
                nfts: [],
                nft_stakings: [],
                jiepop: false,
                zhiyapop: false,
                nft_count: 0,
                nft_staking_count: 0,
                node_name: "",
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {
            let vm = this
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);
			}
            vm.getIndex()
        },
		methods: {
            async extract(item) {
                const vm = this;
                if (!vm.web3) return;
                if (!vm.address) return;

                vm.paying = true;
                vm.loadingPopup = true;
                try {
                    // 先调用后端接口，成功后再继续链上交易
                    try {
                        const resp = await ajaxData("/nft/remove", { id: item.id });
                        console.log("/nft/remove resp", resp);
                    } catch (apiErr) {
                        console.error("/nft/remove error", apiErr);
                        vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
                        vm.paying = false;
                        vm.loadingPopup = false;
                        return; // 接口异常直接结束，不继续链上操作
                    }

                    const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);
                    await stakingContract.methods.unstake(item.stake_id).send({
                        from: vm.address
                    });

                    vm.$message.success("操作成功，请稍后刷新查看")
                    vm.jiepop = false
                    // Refresh data
                    vm.getIndex();
                } catch (e) {
                    console.error("Unstaking error:", e);
                } finally {
                    vm.paying = false;
                    vm.loadingPopup = false;
                }
            },
            getjieyaClick(e){
                this.poptype = e
                if(e == 1){
                    this.jiepop = true
                }else{
                    this.zhiyapop = true
                }
            },
            async staking(item) {
                const vm = this;
                if (!vm.web3) return;
                if (!vm.address) return;

                vm.paying = true;
                vm.loadingPopup = true;
                try {
                    const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);

                    const ids = await stakingContract.methods.getUserActiveStakeIdsByScenario(vm.address, 3).call();
                    if (ids.length > 0) {
                        vm.$message.error("您已经质押");
                        vm.paying = false;
                        vm.loadingPopup = false;
                        return;
                    }

                    // 1. Check if approved
                    const nftContract = new vm.web3.eth.Contract(nodeNft, vm.nft_address);
                    const isApproved = await nftContract.methods.isApprovedForAll(vm.address, vm.nft_staking_address).call();

                    if (!isApproved) {
                        await nftContract.methods.setApprovalForAll(vm.nft_staking_address, true).send({
                            from: vm.address
                        });
                    }

                    // 2. Call stake


                    await stakingContract.methods.stake(item.id, 1, 3).send({
                        from: vm.address
                    });

                    vm.$message.success("操作成功，请稍后刷新查看")
                    vm.zhiyapop = false
                    // Refresh data
                    vm.getIndex();
                } catch (err) {
                    if (err.message) {
                        vm.$message.error(err.message);
                    } else {
                        vm.$message.error("Failed to fetch user NFTs");
                    }
                    console.error("Staking error:", err);
                } finally {
                    vm.paying = false;
                    vm.loadingPopup = false;
                }
            },
            onCopy(txt) {
                utils.copy(txt)
            },
            async getIndex() {
                let vm = this
                getShowAddress()
                ajaxData("/destroy/team").then(res => {
                    console.log(res)
                    vm.share_url = res.data.share_url;
                    vm.direct_bouns = res.data.direct_bouns;
                    vm.direct = res.data.direct;
                    vm.vip_name = res.data.vip_name;
                    vm.team_bouns = res.data.team_bouns;
                    vm.direct_list = res.data.direct_list;
                    vm.jicha_rato = parseFloat(res.data.jicha_rato) * 100;
                    // Add logic to get user NFTs if needed, or if returned by this API
                    if (res.data.address) vm.address = res.data.address;
                    if (res.data.nfts) vm.nfts = res.data.nfts;
                    if (res.data.nft_stakings) vm.nft_stakings = res.data.nft_stakings;

                    if (vm.nft_stakings) {
                        vm.nft_staking_count = vm.nft_stakings.length;
                    }
                    vm.getUserNfts();
                    // vm.getUserStakeIdsByScenario();
                })
            },
            async getUserStakeIdsByScenario() {
                const vm = this;
                if (!vm.web3) return;
                if (!vm.address) return;
                try {
                    const stakingContract = new vm.web3.eth.Contract(SimpleERC1155StakingAbi, vm.nft_staking_address);
                    const ids = await stakingContract.methods.getUserStakeIdsByScenario(vm.address, 3).call();
                    vm.UserStakeIds = ids
                    console.log("getUserStakeIdsByScenario ids:", ids);
                } catch (err) {
                    console.error("getUserStakeIdsByScenario error:", err);
                }
            },
            async getUserNfts() {
                const vm = this;
                try {
                    if (!vm.web3) {
                        console.warn('Web3 provider is not initialized.');
                        return;
                    }
                    if (!vm.nft_address) {
                        console.warn('Contract address is missing.');
                        return;
                    }
                    const contract = new vm.web3.eth.Contract(nodeNft, vm.nft_address);
                    // console.log("vm.address",vm.address)
                    const data = await contract.methods.getUserNodes(vm.address).call();
                    console.log('getUserNodes result:', data);
                    const nodeIds = (data && (data.nodeIds || data[0])) || [];
                    const amounts = (data && (data.amounts || data[1])) || [];

                    // Create a map for easier lookup: id -> balance
                    let balanceMap = {};
                    for (let i = 0; i < nodeIds.length; i++) {
                        balanceMap[String(nodeIds[i])] = amounts[i];
                    }

                    let totalCount = 0;

                    // Filter and update existing nfts from API
                    if (vm.nfts && vm.nfts.length > 0) {
                        vm.nfts = vm.nfts.map(item => {
                            // Map balance using item.id, defaulting to 0 if not found
                            const balance = balanceMap[String(item.id)];
                            item.balance = balance ? balance.toString() : '0';
                            return item;
                        }).filter(item => Number(item.balance) > 0);

                        // Calculate total count based on filtered items
                        vm.nfts.forEach(item => {
                            totalCount += Number(item.balance);
                        });
                    }

                    vm.nft_count = totalCount;
                    console.log("nfts", vm.nfts);
                } catch (err) {
                    console.error('Failed to fetch user NFTs from contract:', err);
                }

            },
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.destroy-team-item1-bg-image {
		background-image: url("~@/assets/images/pages/destroy-team/itemBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.destroy-team-item2-bg-image {
		width: 218rem;
		height: 170rem;
		background-image: url("~@/assets/images/pages/destroy-team/bj2.png");
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-position: bottom;
		background-color: #19191A;
	}

	.jieya{
		display: flex;
		flex-direction: row;
		margin-top: 15px;
	}
	.jieyabtn{
		height: 50px;
		background: rgba(235, 71, 12,0.2);
		border-radius: 25px;
		display: flex;
		width: 48%;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #EB470C;
	}
	.zhiya{
		margin-left: auto;
		background: #EB470C;
		color: #fff;
	}
	.jiepopview{
		background: #19191A;
		border-radius: 15px 15px 0px 0px;
		padding: 20px;
	}
	.jieone{
		display: flex;
		flex-direction: row;
		align-items: center;

	}
	.xname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.icon_gb{
		margin-left: auto;
		width: 16px;
		height: 16px;

	}
	.dqian{

		background: #3C3106;
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 20px 0;
		position: relative;
	}
	.dqnavs{
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 15px 15px;
		width: 100%;
	}
	.jiebg{
		position: absolute;
		width: 100%;
		height: 100%;
	}
	.hguan{
		width: 44px;
		height: 44px;
		margin-right: 10px;
	}
	.dright{
		width: 70%;
		display: flex;
		flex-direction: column;
	}
	.djie{
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}
	.djietwo{
		font-weight: 400;
		font-size: 12px;
		color: #999999;
		display: block;
		margin-top: 10px;
	}
	.yixuan{
		display: block;
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 20px;
		margin-bottom: 20px;
	}
	.yixuannum{
		font-weight: bold;
		font-size: 16px;
		display: inline-block;
		margin-left: 4px;
		color: #FFFFFF;
	}
	.plist{
		overflow-y: scroll;
		max-height: 300px;
	}
	.pitem{
		background: #262626;
		border-radius: 10px;
		border: 0.5px solid #EB470C;
		padding: 10px;
		display: flex;
		flex-direction: row;
		margin-bottom: 15px;
	}
	.pitem:last-child{
		margin-bottom: 0;
	}
	.img_logoimg{
		width: 60px;
		height: 60px;
		margin-right: 10px;
	}
	.pnav{
		width: 78%;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.pnavone{
		display: flex;
		flex-direction: column;

	}
	.pnavname{
		font-weight: 500;
		font-size: 15px;
		color: #FFFFFF;
	}
	.pnabiao{
		font-weight: 500;
		font-size: 10px;
		color: #999999;
		display: block;
		margin: 6px 0;
	}
	.bqitem{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.bqnav{
		padding: 2px 6px;
		background: rgba(235,71,12,0.2);
		border-radius: 3px;
		border: 1px solid #FF902D;
		font-weight: 400;
		font-size: 10px;
		color: #FF902D;
	}
	.quan{
		width: 18px;
		height: 18px;
		margin-left: auto;
	}
	.bot{
		padding: 20px 0 0;
	}
	.zhibtn{
		height: 50px;
		background: #EB470C;
		border-radius: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.jieyabtnnew{
		margin-left: auto;
		height: 40px;
		background: #EB470C;
		border-radius: 10px;
		display: flex;
		padding: 0 25px;

		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}
</style>




